// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Tq8_","col":"styles_col__v8pgR"};